import { Component, Model, Prop, Vue } from 'vue-property-decorator';
import MiDataTable, { MiDataTableVisibility } from '@/components/MiDataTable/MiDataTable';
import { User } from '@/models/User';
import CreateUserDialog from '@/views/Contractors/Users/CreateUserDialog/CreateUserDialog.vue';
import { Contractor } from '@/models/Contractor';

@Component<Users>({
  components: {
    CreateUserDialog,
  },
})
export default class Users extends Vue {
  protected $pageTitle = 'Gebruikers';

  @Model('contractor', { default: () => new Contractor() })
  protected contractor!: Contractor;

  @Prop({ default: false })
  protected syncing!: boolean;

  protected users: User[] = [];

  protected isCreatingUser = false;

  protected refreshDatatable(): void {
    this.datatable.refresh();
  }

  protected get tableOptions(): Record<string, unknown> {
    if (! this.contractor) {
      return {};
    }
    return {
      model: new User().include('contractor').filter({ contractor: this.contractor.uuid }),
      name: {
        singular: 'Herstelbedrijf',
        plural: 'Herstelbedrijven',
      },
      headers: [
        {
          text: 'Naam',
          value: 'name',
          sortable: true,
        },
        {
          text: 'Email',
          value: 'email',
          sortable: true,
        },
      ],
    };
  }

  protected get datatable(): MiDataTable {
    return this.$refs.userDatatable as MiDataTable;
  }

  protected get visibility(): MiDataTableVisibility {
    return {
      filters: false,
      search: true,
    };
  }
}
